<video
  class="video-js vjs-fill vjs-theme-sea"
  controls
  playsinline
  preload="auto"
  crossorigin="anonymous"
  [id]="id"
  [src]="playable_content.url"
></video>
